import styled from 'styled-components';
import { FONTS, SIZE } from '@app/src/ui';

export const Wrapper = styled.div`
  text-align: right;
  margin-top: 0;
  padding-right: 40px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    line-height: initial;
  }
`;

export const Description = styled.ul`
  display: flex;
  flex-direction: column;

  li {
    margin: 0 0 4px;
  }
`;

export const Link = styled.a`
  font-family: ${FONTS.ROBOTO};
  color: #aaa;
  font-size: 13px;
  word-break: break-all;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 15px;
  }
`;

export const Title = styled.h3`
  font-family: ${FONTS.ROBOTO_BOLD};
  color: #666;
  font-size: 13px;
  margin: 0 0 4px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;
